import { useSite } from "@/context/SiteContext";
import { Kicker, Reveal } from "@/components/Reveal";

export const Application = () => {
    const { t } = useSite();
    return (
        <section id="application" data-testid="application-section" className="theme-fade mesh-soft">
            <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-32 lg:px-12 lg:py-40">
                <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
                    <Reveal className="lg:col-span-8">
                        <Kicker>{t.application.kicker}</Kicker>
                        <h2 className="headline-section mt-6 max-w-[16ch] font-display font-semibold text-theme-ink" data-testid="application-heading">
                            {t.application.heading}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="flex items-end lg:col-span-4">
                        <p className="max-w-[40ch] text-base leading-[1.85] text-theme-muted" data-testid="application-body">
                            {t.application.body}
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3 lg:gap-8">
                    {t.application.items.map((item, i) => (
                        <Reveal key={item.name} delay={i * 0.1}>
                            <article data-testid={`application-item-${i}`} tabIndex={0} className="group focus:outline-none">
                                <div className="overflow-hidden rounded-2xl border border-theme">
                                    <img
                                        src={item.img}
                                        alt={item.alt}
                                        loading="lazy"
                                        width="1400"
                                        height="900"
                                        className="aspect-[4/5] w-full object-cover grayscale transition-[filter,transform] duration-700 group-hover:scale-[1.05] group-hover:grayscale-0 group-focus:scale-[1.05] group-focus:grayscale-0"
                                    />
                                </div>
                                <span aria-hidden="true" className="mt-6 block font-display text-base font-medium tracking-[0.2em] text-sky-ink">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-3 font-display text-xl font-semibold uppercase leading-snug tracking-[0.06em] text-theme-ink sm:text-2xl">
                                    {item.name}
                                </h3>
                                <p className="mt-3 max-w-[38ch] text-base leading-[1.8] text-theme-muted">{item.desc}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
